var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.288 37.266c-4.296 0-42.26.585-46.946.585-4.687 0-5.344-3.111-5.344-6.815 1.044 0 11.559.077 22.916.163 0 2.245.191 2.282 5.421 2.282s5.359-.113 5.359-2.201c10.616.079 20.958.146 23.31.146-.001 2.339-.738 5.84-4.716 5.84zm-5.618-7.953l.217-24.48-37.938-.46.368 24.842-3.559-.01c-.008-.042-.34-21.315-.284-23.896C6.548 1.926 7.527.85 10.458.85c2.363 0 34.103.052 37.131.117 3.453.074 3.948 1.697 3.948 4.83 0 2.287-.624 23.524-.624 23.524l-3.243-.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.60e59de93548c52f18fde7d7e25f5ad5.svg";
export { ForwardRef as ReactComponent };